import {
  VERIFIED_PHONE_AT_KEY,
  VERIFIED_PHONE_KEY,
  VERIFIED_PHONE_OWNER_KEY,
} from "./sessionStorage";

export const GOOGLE_MAP_LIBRARIES: "places"[] = ["places"];

export const GENERAL_CLEANING_DRAFT_KEY = "booking_draft:cleaning";
export const CLEANING_STEP_KEY = "general_cleaning_current_step";
export const CLEANING_PROGRESS_STEP_KEY = "general_cleaning_progress_step";
export const CLEANING_POST_LOGIN_CHECK_KEY = "general_cleaning_post_login_check";
export const CLEANING_SELECTED_PACKAGE_KEY = "general_cleaning_selected_package";
export const CLEANING_REFERRAL_HOURS_KEY = "general_cleaning_referral_hours";

export const GENERAL_CLEANING_FREQUENCIES = [
  "one_time",
  "weekly",
  "fortnightly",
] as const;

export const AIRCON_DRAFT_KEY = "booking_draft:aircon";
export const AIRCON_STEP_KEY = "aircon_current_step";
export const AIRCON_PROGRESS_STEP_KEY = "aircon_progress_step";
export const AIRCON_POST_LOGIN_CHECK_KEY = "aircon_post_login_check";

export const AIRCON_FREQUENCIES = ["one_time", "quarterly"] as const;

// Tracks which user owns the active checkout session.
// Persists across logout so the next login can detect a user switch.
export const CHECKOUT_SESSION_OWNER_KEY = "checkout_session_owner";
export const PENDING_BOOKING_KEY = "pending_booking";
export const PENDING_PROMO_KEY = "pending_promo";
export const BOOKING_SUCCESS_CONTEXT_KEY = "booking_success_context";

export const PENDING_PACKAGE_KEY = "pending_package_purchase";
export const PKG_SERVICE_ADDRESS_KEY = "package_service_address";
export const PACKAGE_SUCCESS_CONTEXT_KEY = "package_success_context";
export const PACKAGE_PENDING_DEF_KEY = "package_pending_def_id";
export const PKG_PURCHASE_STEP_KEY = "pkg_purchase_step";
export const PKG_PURCHASE_PROGRESS_KEY = "pkg_purchase_progress";
export const PKG_PURCHASE_DEF_KEY = "pkg_purchase_def_id";

export const MY_CART_RESUME_EVENT = "my-cart:resume";

// localStorage key tracking when the package upsell dialog was last shown (ms timestamp)
export const PKG_UPSELL_LAST_SHOWN_KEY = "hh:pkg_upsell_last_shown";

export const DONE_SESSION_STATUSES = ["completed", "cancelled", "terminated"];

const CHECKOUT_SESSION_KEYS = [
  VERIFIED_PHONE_KEY,
  VERIFIED_PHONE_OWNER_KEY,
  VERIFIED_PHONE_AT_KEY,
  GENERAL_CLEANING_DRAFT_KEY,
  CLEANING_STEP_KEY,
  CLEANING_PROGRESS_STEP_KEY,
  CLEANING_POST_LOGIN_CHECK_KEY,
  CLEANING_SELECTED_PACKAGE_KEY,
  CLEANING_REFERRAL_HOURS_KEY,
  AIRCON_DRAFT_KEY,
  AIRCON_STEP_KEY,
  AIRCON_PROGRESS_STEP_KEY,
  AIRCON_POST_LOGIN_CHECK_KEY,
  PENDING_BOOKING_KEY,
  PENDING_PROMO_KEY,
  PENDING_PACKAGE_KEY,
  PKG_SERVICE_ADDRESS_KEY,
] as const;

export function clearBookingDraftKeys() {
  sessionStorage.removeItem(GENERAL_CLEANING_DRAFT_KEY);
  sessionStorage.removeItem(CLEANING_STEP_KEY);
  sessionStorage.removeItem(CLEANING_PROGRESS_STEP_KEY);
  sessionStorage.removeItem(CLEANING_SELECTED_PACKAGE_KEY);
  sessionStorage.removeItem(CLEANING_REFERRAL_HOURS_KEY);
  sessionStorage.removeItem(AIRCON_DRAFT_KEY);
  sessionStorage.removeItem(AIRCON_STEP_KEY);
  sessionStorage.removeItem(AIRCON_PROGRESS_STEP_KEY);
  sessionStorage.removeItem(PACKAGE_PENDING_DEF_KEY);
  sessionStorage.removeItem(PKG_PURCHASE_STEP_KEY);
  sessionStorage.removeItem(PKG_PURCHASE_PROGRESS_KEY);
  sessionStorage.removeItem(PKG_PURCHASE_DEF_KEY);
}

export function clearCheckoutSession() {
  CHECKOUT_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
}

export function clearPostCheckoutSession() {
  clearCheckoutSession();
  sessionStorage.removeItem(CHECKOUT_SESSION_OWNER_KEY);
}
